import { Icon } from "@iconify/react/dist/iconify.js";

const CreateUserForm = ({ 
    email, 
    setEmail, 
    firstName, 
    setFirstName, 
    lastName, 
    setLastName, 
    selectedRole, 
    setSelectedRole, 
    selectedOrg, 
    organizations, 
    roles, 
    onCreate 
}) => {
    return (
        <div className="flex flex-col justify-between w-full h-full px-2 pb-2 sm:pb-3 sm:px-3 rounded-lg">
            <div className="flex flex-col gap-4">
                <div className="text-xl flex items-center gap-3 pb-3">
                    <Icon icon="mdi:user-add" className="text-4xl text-accent" />
                    <div>
                        <h3 className="font-semibold">Create User</h3>
                        <p className="text-sm text-font-secondary">Add a new member to this organization</p>
                    </div>
                </div>

                <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-2">
                        <label className="text-sm font-medium text-font-primary flex items-center gap-1">
                            <Icon icon="mdi:email" className="text-xl text-accent" />
                            Email Address
                        </label>
                        <input
                            className="w-full p-2 sm:p-3 input-textbox"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            placeholder="user@example.com"
                            type="email"
                        />
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div className="flex flex-col gap-2">
                            <label className="text-sm font-medium text-font-primary flex items-center gap-1">
                                <Icon icon="mdi:account" className="text-xl text-accent" />
                                First Name
                            </label>
                            <input
                                className="w-full p-2 sm:p-3 input-textbox"
                                value={firstName}
                                onChange={e => setFirstName(e.target.value)}
                                placeholder="John"
                                type="text"
                            />
                        </div>

                        <div className="flex flex-col gap-2">
                            <label className="text-sm font-medium text-font-primary flex items-center gap-1">
                                <Icon icon="mdi:account" className="text-xl text-accent" />
                                Last Name
                            </label>
                            <input
                                className="w-full p-2 sm:p-3 input-textbox"
                                value={lastName}
                                onChange={e => setLastName(e.target.value)}
                                placeholder="Doe"
                                type="text"
                            />
                        </div>
                    </div>

                    <div className="flex flex-col gap-2">
                        <label className="text-sm font-medium text-font-primary flex items-center gap-1">
                            <Icon icon="mdi:shield-account" className="text-xl text-accent" />
                            User Role
                        </label>
                        <select
                            value={selectedRole}
                            onChange={e => setSelectedRole(e.target.value)}
                            className="w-full p-2 sm:p-3 input-textbox"
                        >
                            <option value="">Select Role</option>
                            {roles.map(role => (
                                <option key={role.id} value={role.id}>{role.name}</option>
                            ))}
                        </select>
                    </div>

                    <div className="flex flex-col gap-2">
                        <label className="text-sm font-medium text-font-primary flex items-center gap-1">
                            <Icon icon="mdi:office-building" className="text-xl text-accent" />
                            Organization
                        </label>
                        <select
                            value={selectedOrg}
                            className="w-full p-2 sm:p-3 input-textbox bg-bgAccent"
                            disabled
                        >
                            {organizations.map(org => (
                                <option key={org.id} value={org.id} selected={org.id === selectedOrg}>
                                    {org.display_name || org.name}
                                </option>
                            ))}
                        </select>
                        <p className="text-xs text-gray-500">Organization is automatically selected</p>
                    </div>
                </div>
            </div>
            <button
                    onClick={onCreate}
                    disabled={!email || !selectedRole}
                    className="p-4 w-full flex flex-row group items-center justify-center button-container text-sm sm:text-base font-semibold rounded-lg disabled:text-font-secondary disabled:cursor-not-allowed transition-colors gap-2"
                >
                    <Icon icon="mdi:account-plus" className="responsive-icon-sm text-primary group-disabled:text-font-secondary" />
                    Create User
                </button>
        </div>
    );
};

export default CreateUserForm;
